import { parse, stringify } from "query-string";
import omit from "lodash.omit";

const getUrlParameters = () => parse(window.location.search);

const hasUrlParameter = field => {
  const urlParams = getUrlParameters();
  return Object.prototype.hasOwnProperty.call(urlParams, field);
};

const getUrlParameter = field => {
  const urlParams = getUrlParameters();
  return urlParams[field];
};

const removeUrlParameters = (...fields) => {
  const urlParams = getUrlParameters();
  const url = stringify(omit(urlParams, [...fields]));
  window.history.pushState(null, null, `?${url}`);
};

const removeUrlParameter = field => removeUrlParameters([field]);

export { getUrlParameters, hasUrlParameter, getUrlParameter, removeUrlParameters, removeUrlParameter };